import { TBroadcastScheduleProgramBodySegmentToolkitCutForm } from '../types';

const CUT_FORM_DEFAULT_VALUES: TBroadcastScheduleProgramBodySegmentToolkitCutForm = {
  description: '',
  start_datetime: null,
  end_datetime: null,
  seccion: '',
  review_state: 0,
  program_id: null,
};

export { CUT_FORM_DEFAULT_VALUES };
